export enum AccountSettingsWidget {
  'Password',
  'Username',
  'PhoneNumber',
  'Email'
}
